import {Component} from "@angular/core";
import {DialogService} from "../../bootstrap-modal/dialog.service";
import {DialogComponent} from "../../bootstrap-modal/dialog.component";
import "rxjs/add/operator/toPromise";
import {Observable} from "rxjs";
import {ProjectService} from "../../project/project.service";
import {handleErrors} from "../../misc/handle-errors.decorator";

export interface RejectCustomerFleetDialogModel {
  projectId: string;
}

@Component({
  templateUrl: "./reject-customer-fleet-dialog.template.pug",
  providers: [
    ProjectService,
  ],
})
export class RejectCustomerFleetDialogComponent
  extends DialogComponent<RejectCustomerFleetDialogModel, any> implements RejectCustomerFleetDialogModel {
  public projectId: string;
  public error: Error;
  public rejectReasons: string;

  static RejectCustomerFleet(dialogService: DialogService, inputs: RejectCustomerFleetDialogModel): Observable<any> {
    return dialogService.addDialog(RejectCustomerFleetDialogComponent, inputs, {backdropColor: "rgba(0, 0, 0, 0.5)"});
  }

  cancel(): void {
    this.result = {success: false};
    this.close();
  }

  @handleErrors()
  async reject(): Promise<void> {
    if (!this.rejectReasons || this.rejectReasons.trim().length === 0) {
      this.error = new Error("Please enter the reject reason!");
      return;
    }

    await this.projectService.unassignCustomer(this.projectId).toPromise(); // TODO: replace this with new fleet api
    this.result = {success: true};
    this.close();
  }

  constructor(
    public dialogService: DialogService,
    private projectService: ProjectService,
  ) {
    super(dialogService);
  }
}
